/**
 * Resolve the Business Module portal base URL for post-KYC redirects.
 * Prefer REACT_APP_BUSINESS_URL; otherwise map the current Admin host.
 */
export const getBusinessPortalBaseUrl = () => {
  const configured = process.env.REACT_APP_BUSINESS_URL;
  if (configured && String(configured).trim()) {
    return String(configured).trim().replace(/\/$/, "");
  }

  if (typeof window === "undefined" || !window.location) {
    return "";
  }

  const { protocol, hostname } = window.location;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `${protocol}//${hostname}:3002`;
  }

  // adminqa.karncy.com → businessqa.karncy.com, admin.karncy.com → business.karncy.com
  const businessHost = hostname.replace(/^admin/i, "business");
  return `${protocol}//${businessHost}`;
};

/** Business Module landing after KYC (onboarding questionnaire). */
export const getBusinessPortalKycRedirectUrl = () => {
  const base = getBusinessPortalBaseUrl();
  return base ? `${base}/questionnaire?kycSuccess=1` : "/questionnaire?kycSuccess=1";
};
